import { Sidebar, SidebarItem, SidebarItemGroup, SidebarItems } from "flowbite-react";
import { LayoutDashboard, Laptop, BriefcaseBusiness, UserRound, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function SideNav({ onClose }) {
  return (
    <Sidebar
      aria-label="Main sidebar"
      className="h-full bg-gray-900 w-64"
    >
      <div className="mb-8 px-4 text-white text-xl font-bold tracking-tight flex items-center justify-between">
        <span>Job Maker - PHV</span>
        {onClose && (
          <button onClick={onClose} className="lg:hidden text-white ml-2">
            <X size={20} />
          </button>
        )}
      </div>

      <SidebarItems>
        <SidebarItemGroup>
          <SidebarItem as={Link} to="/dashboard" icon={LayoutDashboard}>
            Dashboard
          </SidebarItem>
          <SidebarItem as={Link} to="/clients" icon={UserRound}>
            Client
          </SidebarItem>
          <SidebarItem as={Link} to="/jobs" icon={BriefcaseBusiness}>
            Jobs
          </SidebarItem>
          <SidebarItem as={Link} to="/items" icon={Laptop}>
            Items
          </SidebarItem>
        </SidebarItemGroup>
      </SidebarItems>
    </Sidebar>
  );
}
